import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHeader({ eyebrow, title, subtitle, image, crumb, homeLabel = "Home" }) {
  return (
    <section className="relative pt-[72px] overflow-hidden grain">
      <div className="absolute inset-0">
        <img src={image} alt={title} loading="eager" fetchPriority="high" decoding="async" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#14110F]/85 via-[#14110F]/75 to-[#14110F]/85" />
      </div>
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-24 lg:py-32">
        <div className="flex items-center gap-1.5 text-white/50 text-sm mb-5">
          <Link to="/" className="hover:text-white transition-colors">{homeLabel}</Link>
          <ChevronRight size={14} />
          <span className="text-[#22B573]">{crumb}</span>
        </div>
        {eyebrow && (
          <span className="inline-block text-[#22B573] font-semibold text-sm uppercase tracking-wider mb-3">{eyebrow}</span>
        )}
        <h1 className="font-display font-extrabold text-white text-4xl lg:text-6xl tracking-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-6 text-white/75 text-lg lg:text-xl max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
